import type { ReactNode } from 'react';

type StoryCardProps = {
  children: ReactNode;
  title?: ReactNode;
};

export const StoryCard = ({ children, title }: StoryCardProps) => {
  return (
    <div className="p-4 md:p-6 rounded-2xl bg-neutral-50 mb-5 md:mb-10">
      {title ? (
        <h2 className="text-lg leading-6 md-msq:text-[32px] md-msq:leading-[40px] text-secondary-700 font-semibold mb-6 mt-0">
          {title}
        </h2>
      ) : undefined}
      {children}
    </div>
  );
};
